import React, { useMemo } from "react";
import classNames from "classnames";
import { InvestorCardData } from "../sections/WhatTypeOfInvestor/const";
import { Button } from "../Button/Button";
import { AccountTier } from "@bundles/consts";

type InvestorCardProps = InvestorCardData & {
  displaySeparator?: boolean;
  userTier?: AccountTier;
};

export const InvestorCard = ({
  tierImage,
  additionalImage,
  title,
  description,
  buttonText,
  buttonLink,
  disclaimer,
  displaySeparator,
  tier,
  userTier,
}: InvestorCardProps) => {
  const descriptionLines = description.split("\n").map((line, index) => (
    <p key={index} className="text-gray-700 mb-4">
      {line}
    </p>
  ));

  const isButtonDisabled = useMemo(() => {
    if (buttonText.includes("Requires")) {
      return true;
    }

    return false;
  }, [buttonText]);

  return (
    <div
      className={classNames(
        "bg-white md:p-6 flex flex-col items-center justify-between md:mx-0 md:pt-0",
        {
          "border-t md:border-t-0 md:border-l border-grey-lighter pt-[20px]":
            displaySeparator,
        }
      )}
    >
      <div>
        <div className="mb-4 flex justify-between">
          <img
            src={tierImage}
            className="max-h-[34px]"
            alt={title}
            width={76}
            height={34}
          />
          {!!additionalImage && (
            <img src={additionalImage} alt={title} width={34} height={40} />
          )}
        </div>
        <div style={{ height: 44 }} className="mb-5">
          {title}
        </div>
        <div className="text-gray-700 mb-6 text-sm">{descriptionLines}</div>
      </div>

      <div className="flex flex-col">
        <Button
          disabled={isButtonDisabled || tier === AccountTier.Tier_3}
          completed={buttonText === "Completed"}
          href={buttonLink}
        >
          {buttonText}
        </Button>
        <p className="text-xs text-grey-lightest mt-4 text-center">
          {disclaimer}
        </p>
      </div>
    </div>
  );
};
